import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useMeState = createStateHook(
  AppStoreProvider,
  state => state.pages.me
)
export const useNextMeState = () =>
  createNextHook(AppStoreProvider, state => state.pages.me)
